var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalmLeafsRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 98,
    viewBox: "0 0 93 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4224 42.7025L87.6501 48.9373L84.472 58.8551L75.2853 58.4939L82.7378 64.3805L78.4757 77.7694C40.2535 43.96 94.8728 26.4096 94.8728 26.4096L90.0317 41.7817L79.4224 42.7025Z",
    fill: "#2A7DFF",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4688 -3.4694C74.1102 -5.17331 82.1198 2.91252 85.0985 9.44194L76.3392 9.90844L72.8904 3.98249L72.1644 10.1445L67.9896 10.3805L61.974 0.223815L60.7992 10.7463L58.411 10.8359L55.2416 5.4016L54.576 10.9545L42.775 11.648C42.8449 11.771 44.8972 -1.64258 59.4688 -3.4694Z",
    fill: "#2A7DFF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5456 27.5679L59.3609 41.198C56.589 43.4082 53.6055 45.5492 50.5519 47.62L41.3481 39.4127L41.3986 52.7014C31.9693 56.795 22.2044 58.2755 13.7564 53.2439C13.7564 53.2439 17.0875 41.6285 25.713 31.0372L32.3327 34.6676L29.6304 26.6986C32.7611 23.7083 36.3139 20.9979 40.4284 18.8492L45.0897 29.7737L49.5692 15.6058C58.2059 13.7089 68.5208 14.4865 80.9966 19.7027C80.9966 19.7027 74.6525 27.4509 65.3346 35.9263L57.5456 27.5679Z",
    fill: "#2A7DFF",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmLeafsRight);
export default __webpack_public_path__ + "static/media/palmLeafsRight.7dd5654ae99b198d961dc34dd04aed57.svg";
export { ForwardRef as ReactComponent };